"use client";

import _slicedToArray from "/codebuild/output/src859445700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useForceUpdate } from "./ABQUS43J.js";

// src/dialog/utils/use-root-dialog.ts
import { getDocument } from "@ariakit/core/utils/dom";
import { useCallback, useEffect } from "react";
import { flushSync } from "react-dom";
function useRootDialog(_ref) {
  var attribute = _ref.attribute,
    contentId = _ref.contentId,
    contentElement = _ref.contentElement,
    enabled = _ref.enabled;
  var _useForceUpdate = useForceUpdate(),
    _useForceUpdate2 = _slicedToArray(_useForceUpdate, 2),
    updated = _useForceUpdate2[0],
    retry = _useForceUpdate2[1];
  var isRootDialog = useCallback(function () {
    if (!enabled) return false;
    if (!contentElement) return false;
    var _getDocument = getDocument(contentElement),
      body = _getDocument.body;
    var id = body.getAttribute(attribute);
    return !id || id === contentId;
  }, [updated, enabled, contentElement, attribute, contentId]);
  useEffect(function () {
    if (!enabled) return;
    if (!contentId) return;
    if (!contentElement) return;
    var _getDocument2 = getDocument(contentElement),
      body = _getDocument2.body;
    if (isRootDialog()) {
      body.setAttribute(attribute, contentId);
      return function () {
        return body.removeAttribute(attribute);
      };
    }
    var observer = new MutationObserver(function () {
      return flushSync(retry);
    });
    observer.observe(body, {
      attributeFilter: [attribute]
    });
    return function () {
      return observer.disconnect();
    };
  }, [updated, enabled, contentId, contentElement, isRootDialog, attribute]);
  return isRootDialog;
}
export { useRootDialog };